/**
 * @file src/lib/affiliate/trackClick.ts
 * @description Client helper that reports a referral or affiliate link click to the server, which sets the
 * visitor cookies. Skipped inside iframes so embedded pages cannot stuff cookies.
 *
 * @called_by ReferralRedirectClient, ReferralProvider
 */

const reported = new Set<string>();

function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

/** Resolves true when the server recorded the click and the display cookies are now set. */
export async function trackReferralClick(code: string, channel?: string | null): Promise<boolean> {
  if (typeof window === "undefined" || isEmbedded()) return false;
  if (reported.has(code)) return true;
  try {
    const res = await fetch("/api/referral/click", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, channel: channel ?? undefined, referrer: document.referrer || undefined }),
    });
    if (!res.ok) return false;
    reported.add(code);
    window.dispatchEvent(new Event("hirecarta_referral_update"));
    return true;
  } catch (error) {
    console.error("[trackReferralClick] Failed to record click:", error);
    return false;
  }
}
